import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import it from './locales/it.json';

/**
 * Type for translation overrides
 *
 * @example
 * const overrides: TranslationOverrides = {
 *   en: {
 *     dropZoneDescription: "Custom drop zone text",
 *     uploadImage: "Custom upload button"
 *   },
 *   de: {
 *     dropZoneDescription: "Benutzerdefinierter Text"
 *   }
 * };
 */
export type TranslationOverrides = {
  [locale: string]: {
    [key: string]: string;
  };
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      de: {
        translation: de
      },
      it: {
        translation: it
      }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

/**
 * Apply translation overrides to i18n instance
 * Overrides are merged with existing translations, with overrides taking precedence
 */
export const applyTranslationOverrides = (overrides?: TranslationOverrides) => {
  if (!overrides) return;

  Object.entries(overrides).forEach(([locale, translations]) => {
    // Get existing translations for this locale
    const existingTranslations = i18n.getResourceBundle(locale, 'translation') || {};

    // Merge with overrides (overrides take precedence)
    const mergedTranslations = {
      ...existingTranslations,
      ...translations
    };

    // Add or update the resource bundle
    i18n.addResourceBundle(locale, 'translation', mergedTranslations, true, true);
  });
};

export default i18n;

